export default __webpack_public_path__ + "static/media/email.351e6aa3.svg";